import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Hero from "@components/Hero"

const StrapiHero = ({
    title,
    overline,
    backgroundImage,
    description,
    buttons
}: GatsbyTypes.HeroFragment) => {
    if (!backgroundImage?.file?.childImageSharp?.gatsbyImageData) {
        return
    }

    return <Hero
        backgroundImage={<GatsbyImage
            loading="eager"
            image={backgroundImage.file.childImageSharp.gatsbyImageData}
            alt={`${backgroundImage?.alternativeText}`}
        />}
        subtitle={overline}
        title={title}
        description={description}
        buttons={buttons as GatsbyTypes.StrapiComponentComponentsButton[]}
    />
}

export default StrapiHero
